import { TOTAL_HOURS } from './constants';
import { CalendarTimeIndicatorLines } from './types';

export const timeToRow = (timeStr: string) => {
  const [hrs, mins] = timeStr.split(':').map(Number);
  return hrs * 60 + mins + 1; // +2 because row 1 is header
};

export const convertToIdMap = <T extends { id: string }>(items: T[]) =>
  items.reduce((acc, item) => {
    acc[item.id] = item;
    return acc;
  }, {} as Record<string, T>);

export const getHourLabels = (timeIndicatorLines: CalendarTimeIndicatorLines) => {
  const labels = [];

  if (timeIndicatorLines === 'none') return [];

  const showHalfHour = timeIndicatorLines === 'half-hourly';
  for (let i = 0; i < TOTAL_HOURS; i++) {
    labels.push(`${i.toString().padStart(2, '0')}:00`);
    if (showHalfHour) {
      labels.push(`${i.toString().padStart(2, '0')}:30`);
    }
  }
  return labels;
};
